import { browserCookies } from '@gousto-internal/storage-consent-web-package'

export const persistenceConfig = (store) => {
  /**
   * hasConsentedBannerCookie will always be true for v1_cookie_banner_variation
   * as this cookie is classified as necessary in storage-consent-web-package for the duration of the A/B test.
   */
  const [hasConsentedBannerCookie, bannerCookieValue] = browserCookies
    .getString('v1_cookie_banner_variation')
  const isBannerVariationT1 = hasConsentedBannerCookie && bannerCookieValue === 't1'
  const [hasConsentedTrackingCookie] = browserCookies.getString('v1_goustoStateStore_tracking')

  let persistentCookies = {
    features: false,
    promoAgeVerified: false,
    variants: false,
    basket: {
    },
    menu: {
    },
    deliveryDetails: {

    }
  }

  if ((isBannerVariationT1 && hasConsentedTrackingCookie) || !isBannerVariationT1) {
    persistentCookies.tracking = false
  }

  if (!store.basket.get('orderId')) {
    persistentCookies = Object.assign(persistentCookies, {
      /* one layer deep only, add the resulting cookie names
      to CookieGuard.php in underscore form */
      basket: {
        postcode: true,
        date: true,
        address: false,
        numPortions: true,
        slotId: true,
        recipes: false,
        previewOrderId: true,
        stepsOrder: false,
        collection: true,
        promoCode: true,
        subscriptionOption: true,
      },
      menu: {
        selectedRecipeVariants: false,
        curatedBoxName: true,
        curatedBoxCollectionId: true,
      },
      deliveryDetails: {
        deliveryInstruction: true,
        deliveryInstructionCustom: true
      }
    })
  }

  return persistentCookies
}

export const cookiePrefix = 'goustoStateStore'

export const cookieExpiries = {
  default: 2 / 24,
  features: 7,
  tracking: 30,
  basket_date: 7,
  basket_numPortions: 7,
  basket_postcode: 7,
  basket_recipes: 7,
  basket_promoCode: 60,
  menu_selectedRecipeVariants: 7,
  menu_curatedBoxName: 7,
  menu_curatedBoxCollectionId: 7,
  deliveryDetails_deliveryInstruction: 7,
  deliveryDetails_deliveryInstructionCustom: 7
}
